declare const __HEADLESS__: boolean;

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Title,
  Interaction,
  InteractionModeFunction,
} from 'chart.js';

import { DataPoint } from './lineGraphComponent.hooks';
declare module 'chart.js' {
  interface InteractionModeMap {
    nearestExcludingZero: InteractionModeFunction;
  }
}

if (__HEADLESS__) {
  window.ChartJS = ChartJS;
}

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Tooltip, Title);

Interaction.modes.nearestExcludingZero = (...args) =>
  Interaction.modes.nearest(...args).filter((item) => {
    const itemWithDataPoint = item as unknown as { element: { $context: { raw: DataPoint } } };
    return itemWithDataPoint.element.$context.raw.tallies;
  });
